import {rebuildBlocks} from './helpers';
import {sigTooltipHandler} from './file_signatures';

let content;

function checkAndRebuildBlocks() {
    if (typeof (rebuildBlocks) === 'function') {
        rebuildBlocks();
    }
}

$_pro(() => {
    content = $_pro('body');

    $_pro('#special-font-size-normal').on('click', () => {
        content.addClass('special-font-size-normal');
        content.removeClass('special-font-size-big');
        content.removeClass('special-font-size-large');
        $_pro('#special-font-size-normal').addClass('special-btn-active');
        $_pro('#special-font-size-big').removeClass('special-btn-active');
        $_pro('#special-font-size-large').removeClass('special-btn-active');
        sessionStorage.setItem('special-font-size', '1');
    });
    $_pro('#special-font-size-big').on('click', () => {
        content.removeClass('special-font-size-normal');
        content.addClass('special-font-size-big');
        content.removeClass('special-font-size-large');
        $_pro('#special-font-size-normal').removeClass('special-btn-active');
        $_pro('#special-font-size-big').addClass('special-btn-active');
        $_pro('#special-font-size-large').removeClass('special-btn-active');
        sessionStorage.setItem('special-font-size', '2');
        checkAndRebuildBlocks();
    });
    $_pro('#special-font-size-large').on('click', () => {
        content.removeClass('special-font-size-normal');
        content.removeClass('special-font-size-big');
        content.addClass('special-font-size-large');
        $_pro('#special-font-size-normal').removeClass('special-btn-active');
        $_pro('#special-font-size-big').removeClass('special-btn-active');
        $_pro('#special-font-size-large').addClass('special-btn-active');
        sessionStorage.setItem('special-font-size', '3');
        checkAndRebuildBlocks();
    });
    $_pro('#special-site-color-black-white').on('click', () => {
        content.addClass('special-site-color-black-white');
        content.removeClass('special-site-color-white-black');
        content.removeClass('special-site-color-darkblue-blue');
        $_pro('#special-site-color-black-white').addClass('special-btn-active');
        $_pro('#special-site-color-white-black').removeClass('special-btn-active');
        $_pro('#special-site-color-darkblue-blue').removeClass('special-btn-active');
        sessionStorage.setItem('special-site-color', '1');
        checkAndRebuildBlocks();
    });
    $_pro('#special-site-color-white-black').on('click', () => {
        content.removeClass('special-site-color-black-white');
        content.addClass('special-site-color-white-black');
        content.removeClass('special-site-color-darkblue-blue');
        $_pro('#special-site-color-black-white').removeClass('special-btn-active');
        $_pro('#special-site-color-white-black').addClass('special-btn-active');
        $_pro('#special-site-color-darkblue-blue').removeClass('special-btn-active');
        sessionStorage.setItem('special-site-color', '2');
        checkAndRebuildBlocks();
    });
    $_pro('#special-site-color-darkblue-blue').on('click', () => {
        content.removeClass('special-site-color-black-white');
        content.removeClass('special-site-color-white-black');
        content.addClass('special-site-color-darkblue-blue');
        $_pro('#special-site-color-black-white').removeClass('special-btn-active');
        $_pro('#special-site-color-white-black').removeClass('special-btn-active');
        $_pro('#special-site-color-darkblue-blue').addClass('special-btn-active');
        sessionStorage.setItem('special-site-color', '3');
        checkAndRebuildBlocks();
    });
    $_pro('#special-font-family-arial').on('click', () => {
        content.addClass('special-font-family-arial');
        content.removeClass('special-font-family-times-new-roman');
        $_pro('#special-font-family-arial').addClass('special-btn-active');
        $_pro('#special-font-family-times-new-roman').removeClass('special-btn-active');
        sessionStorage.setItem('special-font-family', '1');
        checkAndRebuildBlocks();
    });
    $_pro('#special-font-family-times-new-roman').on('click', () => {
        content.removeClass('special-font-family-arial');
        content.addClass('special-font-family-times-new-roman');
        $_pro('#special-font-family-arial').removeClass('special-btn-active');
        $_pro('#special-font-family-times-new-roman').addClass('special-btn-active');
        sessionStorage.setItem('special-font-family', '2');
        checkAndRebuildBlocks();
    });
    $_pro('#special-letter-spacing-normal').on('click', () => {
        content.addClass('special-letter-spacing-normal');
        content.removeClass('special-letter-spacing-big');
        content.removeClass('special-letter-spacing-large');
        $_pro('#special-letter-spacing-normal').addClass('special-btn-active');
        $_pro('#special-letter-spacing-big').removeClass('special-btn-active');
        $_pro('#special-letter-spacing-large').removeClass('special-btn-active');
        sessionStorage.setItem('special-letter-spacing', '1');
        checkAndRebuildBlocks();
    });
    $_pro('#special-letter-spacing-big').on('click', () => {
        content.removeClass('special-letter-spacing-normal');
        content.addClass('special-letter-spacing-big');
        content.removeClass('special-letter-spacing-large');
        $_pro('#special-letter-spacing-normal').removeClass('special-btn-active');
        $_pro('#special-letter-spacing-big').addClass('special-btn-active');
        $_pro('#special-letter-spacing-large').removeClass('special-btn-active');
        sessionStorage.setItem('special-letter-spacing', '2');
        checkAndRebuildBlocks();
    });
    $_pro('#special-letter-spacing-large').on('click', () => {
        content.removeClass('special-letter-spacing-normal');
        content.removeClass('special-letter-spacing-big');
        content.addClass('special-letter-spacing-large');
        $_pro('#special-letter-spacing-normal').removeClass('special-btn-active');
        $_pro('#special-letter-spacing-big').removeClass('special-btn-active');
        $_pro('#special-letter-spacing-large').addClass('special-btn-active');
        sessionStorage.setItem('special-letter-spacing', '3');
        checkAndRebuildBlocks();
    });

    $_pro('body')
        .on('click', '.showpart-btn-list', function () {
            const thisObj = $_pro(this);
            const container = thisObj.prev('.showpart-container-list');
            const status = thisObj.data('status');
            if (status === 1) {
                container.css('max-height', 'none');
                thisObj.css('top', '0')
                    .data('status', 2)
                    .text('скрыть');
            } else {
                container.css('max-height', '50px');
                thisObj.css('top', '-16px')
                    .data('status', 1)
                    .text('показать все');
            }
        })
        .on('click', '.showpart-btn-modal', function () {
            const thisObj = $_pro(this);
            const modal = $_pro('#showpart-modal');
            modal.find('.modal-title').html(thisObj.parent().find('.showpart-title-modal').html());
            modal.find('.modal-body').html(thisObj.parent().find('.showpart-container-modal').html());
            modal.find('.tooltip-sig').tooltip({
                selector: '.tooltip-sig',
                html: true,
                title: sigTooltipHandler,
                placement: 'auto',
                container: modal,
            });
            modal.modal('show');
        });
});
